import React from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

interface MediaSelectorProps {
  onTabSwitch: (args: string) => void;
  isVideo: boolean;
  currentTabView: string;
}

const TabsWrapper = styled.div<{ isVideo: boolean }>`
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid
    ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.16)};
  align-items: center;
  cursor: pointer;
  .active {
    color: ${({ theme }) => theme.colors.primary30};
    border-bottom: ${({ theme }) => theme.borders.radius10} solid
      ${({ theme }) => theme.colors.primary30};
  }
`;

const TabItem = styled.div<{ isVideo: boolean }>`
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.64)};
  padding: 17px 0px;
  ${({ theme }) => theme.typography.subTitleLarge};
  text-align: center;
  flex: 1;
  &:hover {
    background: ${({ theme }) => hexToRgb(theme.colors.state, 0.08)};
  }
`;

const MediaSelector = ({
  isVideo,
  onTabSwitch,
  currentTabView,
}: MediaSelectorProps) => (
  <TabsWrapper isVideo={isVideo}>
    <TabItem
      isVideo={isVideo}
      onClick={() => {
        onTabSwitch('image');
      }}
      className={`tab-text ${currentTabView === 'image' ? 'active' : ''}`}
    >
      Images
    </TabItem>
    <TabItem
      isVideo={isVideo}
      onClick={() => {
        onTabSwitch('video');
      }}
      className={`tab-text ${currentTabView === 'video' ? 'active' : ''}`}
    >
      Videos
    </TabItem>
  </TabsWrapper>
);
export default MediaSelector;
